"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import useIsMobile from "../../common/utils/useIsMobile";
import { usePathname } from "../../../navigation";

const NavigationWrapper = ({ children, navigationData }) => {
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const pathname = usePathname();

  const resetMenuState = useCallback(() => {
    setMobileMenuOpen(false);
    setSelectedLayout(null);
  }, []);
  const isMobile = useIsMobile(resetMenuState);
  const menuRef = useRef(null);

  const handleTopLevelClick = (item) => {
    setSelectedLayout(
      item?.meta?.layout === selectedLayout
        ? null
        : item?.meta?.layout || "services",
    );
  };
  const backToMainMenu = () => {
    setSelectedLayout(null);
  };
  useEffect(() => {
    const handleMouseOut = (event) => {
      if (
        !isMobile &&
        ((menuRef.current && !menuRef.current.contains(event.relatedTarget)) ||
          event.target.closest("#navigation-search-input") ||
          event.target.closest("#top-nav"))
      ) {
        resetMenuState();
      }
    };

    const handleClickOutside = (event) => {
      if (
        !isMobile &&
        ((menuRef.current && !menuRef.current.contains(event.target)) ||
          event.target.closest("#navigation-search-input") ||
          event.target.closest("#top-nav"))
      ) {
        resetMenuState();
      }
    };

    if (menuRef.current) {
      menuRef.current.addEventListener("mouseout", handleMouseOut);
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      if (menuRef.current) {
        menuRef.current.removeEventListener("mouseout", handleMouseOut);
      }
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [resetMenuState, isMobile]);
  const currentNavigation = navigationData.find(
    ({ meta }) =>
      meta?.layout === selectedLayout ||
      (selectedLayout === "services" && !meta?.layout),
  );

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen((prev) => !prev);
    setSelectedLayout(null);
  }, []);

  useEffect(() => {
    resetMenuState();
  }, [pathname]);

  return children({
    isMobile,
    selectedLayout,
    setSelectedLayout,
    handleTopLevelClick,
    toggleMobileMenu,
    currentNavigation,
    menuRef,
    resetMenuState,
    isMobileMenuOpen,
    backToMainMenu,
  });
};

export default NavigationWrapper;
